/* AMC checkout enhance: quick-add polish, one-layer flyouts, trust footer (real payment logos), quote flyout cleanup, PO/RFQ confirmation notice, viewing-card monthly price. */
(function(){
  if(window.__amcCheckoutEnhance)return;window.__amcCheckoutEnhance=true;
  var queued=false;
  var BTN={'min-height':'52px','height':'52px','width':'100%','background':'#0874df','border':'0','color':'#fff','border-radius':'999px'};
  var PLUS={'width':'34px','height':'34px','flex':'0 0 34px','background':'#fff','color':'#0874df','font-size':'28px'};
  var LOCK='<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';
  function apply(node,map){
    Object.keys(map).forEach(function(k){
      if(node.style.getPropertyValue(k)!==map[k]||node.style.getPropertyPriority(k)!=='important')node.style.setProperty(k,map[k],'important');
    });
  }
  function oneLayer(){
    var sp=document.getElementById('amc-sp');
    if(!sp||sp.hidden)return;
    if(document.querySelector('modal-dialog[open], cart-drawer.active, cart-drawer[open]')) sp.hidden=true;
  }
  function trust(title,sub){
    var tpl=document.querySelector('template[data-amc-trust-tpl]');
    if(!tpl)return null;
    var n=tpl.content.firstElementChild.cloneNode(true);
    n.querySelector('[data-amc-trust-title]').textContent=title;
    var s=n.querySelector('[data-amc-trust-sub]');
    if(sub)s.textContent=sub;else s.remove();
    return n;
  }
  function bigAdd(){
    document.querySelectorAll('.amc-cd-rec__add').forEach(function(a){
      a.classList.add('amc-qa-big');
      apply(a,BTN);
      var p=a.querySelector('.amc-qa-plus');
      if(p)apply(p,PLUS);
    });
  }
  /* Cart page + flyout: the Checkout button itself reads "Checkout securely" (lock icon); payment logos sit directly under it. */
  function cartTrust(){
    document.querySelectorAll('cart-drawer .cart__ctas, #main-cart .cart__ctas, cart-items ~ * .cart__ctas').forEach(function(ctas){
      var host=ctas.parentElement;
      if(!host)return;
      var have=host.querySelectorAll(':scope > [data-amc-trust]');
      for(var i=1;i<have.length;i++)have[i].remove();
      var t=have[0];
      if(!t){t=trust('Checkout securely','Your payment information is encrypted');if(!t)return;}
      if(ctas.nextElementSibling!==t)ctas.after(t);
      var b=ctas.querySelector('button[name="checkout"]');
      if(b&&!b.classList.contains('amc-secure-btn')){
        b.classList.add('amc-secure-btn');
        var sp=b.querySelector('span:not(.loading__spinner)');
        if(sp){sp.innerHTML=LOCK+'<span>Checkout securely</span>';sp.style.cssText='display:inline-flex;align-items:center;gap:8px';}
        else b.innerHTML=LOCK+'<span>Checkout securely</span>';
      }
    });
  }
  function quoteFlyout(){
    document.querySelectorAll('.amc-qd__btn--getq').forEach(function(a){
      if(a.textContent.trim()!=='Finish my quote now')a.textContent='Finish my quote now';
    });
    document.querySelectorAll('.amc-qd__mail--lead h3').forEach(function(h){
      if(h.textContent.trim()!=='Finish my quote now')h.textContent='Finish my quote now';
    });
    document.querySelectorAll('.amc-qd__mail--lead .amc-qd__hint').forEach(function(p){
      var s='We email your quote with a link to reopen it. A specialist follows up.';
      if(p.textContent.trim()!==s)p.textContent=s;
    });
    document.querySelectorAll('.amc-qd__foot').forEach(function(f){
      if(f.querySelector('[data-amc-trust]'))return;
      var t=trust('Secure quote and checkout','Your information is encrypted');
      if(t)f.prepend(t);
    });
    document.querySelectorAll('.amc-qb__buy--alt').forEach(function(b){
      if(b.querySelector('[data-amc-trust]'))return;
      var t=trust('Checkout securely','Your payment information is encrypted');
      if(t)b.append(t);
    });
  }
  /* Viewing-set cards: no Shop Pay logo on the card. Show "From $X/mo" beside the red price instead (logo appears in cart/checkout).
     The style goes in a layer declared FIRST so its !important rules beat the older card layers.
     The Shop Pay widget stays rendered (invisible via opacity) so its monthly amount can be read. */
  var VCSTYLE=false;
  function vcStyle(){
    if(VCSTYLE)return;VCSTYLE=true;
    var V='.amc-viewing-conversions ';
    var s=document.createElement('style');
    s.textContent='@layer amcmine{'+
      V+'.amc-viewing-card__pay{display:block!important;position:absolute!important;left:0!important;bottom:0!important;width:200px!important;height:24px!important;overflow:hidden!important;opacity:0!important;pointer-events:none!important}'+
      V+'.amc-viewing-card__prices{display:flex!important;flex-wrap:wrap!important;align-items:center!important;gap:2px 8px!important}'+
      V+'.amc-viewing-card__prices .amc-sale-tag{order:1!important}'+
      V+'.amc-viewing-card__prices .amc-trending-card__reference{order:2!important;flex:1 0 calc(100% - 60px)!important}'+
      V+'.amc-viewing-card__prices .amc-trending-card__price{order:3!important;flex:0 0 auto!important;color:#D71920!important;font-size:19px!important;line-height:24px!important;font-weight:800!important}'+
      V+'.amc-viewing-card__prices .amc-trending-card__price small{color:#8A1218!important}'+
      V+'.amc-vc-mo{order:4;align-self:center;font-size:14px;line-height:24px;font-weight:800;color:#061A35;white-space:nowrap}'+
      V+'.amc-vc-mo i{font-style:normal;font-weight:500;color:#5E7080;font-size:12px}'+
      '}';
    document.head.insertBefore(s,document.head.firstChild);
  }
  function vcMonthly(){
    var cards=document.querySelectorAll('.amc-viewing-conversions li.amc-trending-card');
    if(!cards.length)return;
    vcStyle();
    cards.forEach(function(li){
      var prices=li.querySelector('.amc-viewing-card__prices');
      if(!prices||prices.querySelector('.amc-vc-mo'))return;
      var t=li.querySelector('.amc-viewing-card__pay shopify-payment-terms'),amt='';
      if(t&&t.shadowRoot){
        var b=t.shadowRoot.querySelector('#shopify-installments-content .font-bold');
        if(b)amt=b.textContent.trim();
      }
      if(!/\$\s?\d/.test(amt))return;
      var sp=document.createElement('span');sp.className='amc-vc-mo';
      sp.innerHTML='<i>From</i> '+amt.replace(/</g,'')+'<i>/mo</i>';
      prices.appendChild(sp);
    });
  }
  /* PO / RFQ confirmation view: response-time notice + clear phone number. */
  function poConfirm(){
    var ok=document.querySelector('[data-po-done]:not([hidden]) .amc-ok--po');
    if(!ok||ok.parentNode.querySelector('[data-amc-po-notice]'))return;
    var rfq=/request for quote/i.test((ok.querySelector('.amc-ok__lede')||{}).textContent||'');
    var c=rfq?'#D71920':'#0874DF';
    var n=document.createElement('div');
    n.setAttribute('data-amc-po-notice','');
    n.setAttribute('role','note');
    n.style.cssText='margin:14px 0;padding:16px 18px;border-radius:12px;background:#fff;border:1px solid #E6E8EC;border-left:5px solid '+c+';color:#061A35;font-size:15px;line-height:1.45';
    n.innerHTML=(rfq?'<strong style="display:block;font-size:17px;margin-bottom:4px">Please allow up to 24 hours for your formal quote.</strong>We price every line, including freight to your delivery address, and email the quote to you. ':'<strong style="display:block;font-size:17px;margin-bottom:4px">Your purchase order is with our team.</strong>We confirm items, delivery address and freight with you before anything ships. ')+'Need it sooner? Call <a href="tel:+18887929315" style="color:'+c+';font-weight:800;text-decoration:none;white-space:nowrap">1-888-792-9315</a> (Mon–Fri, 7:30 AM–6:00 PM ET) and give us your reference number.';
    ok.after(n);
  }
  function run(){
    queued=false;
    bigAdd();cartTrust();quoteFlyout();oneLayer();poConfirm();vcMonthly();
  }
  function q(){if(!queued){queued=true;setTimeout(run,30);}}
  new MutationObserver(q).observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['style','class','open','hidden']});
  q();
  /* Shop Pay terms render asynchronously; retry until every viewing card has its monthly price. */
  var vt=0,viv=setInterval(function(){vcMonthly();if(++vt>60)clearInterval(viv);},750);
  var tries=0,iv=setInterval(function(){
    if(window.AMCQuote){window.AMCQuote.print=function(){};clearInterval(iv);}
    else if(++tries>80)clearInterval(iv);
  },150);
})();
